import { useMemo } from 'react';
import { useListAllBrokerGroupsQuery } from '../brokerGroups/api/brokerGroupsApi';
import { getUserSearchOptions } from './searchOptions';

/**
 * Fuse options for searching users, with broker group names read from the cached full
 * broker group list. Stable until that list changes.
 */
export const useUserSearchOptions = () => {
	const { data: brokerGroups } = useListAllBrokerGroupsQuery();

	return useMemo(
		() =>
			getUserSearchOptions(
				new Map((brokerGroups ?? []).map((brokerGroup) => [brokerGroup.id, brokerGroup.name])),
			),
		[brokerGroups],
	);
};
